import Floor from "../Floor/Floor.js";
import App from "@templates/App/App.js";
import Navigator from "@modules/navigator/Navigator.js";
import BuildingBubble from "./BuildingBubble/BuildingBubble.js";
import BannerParallax from "../../../templates/src/Components/BannerParallax/BannerParallax.js";
import {gsap} from "gsap";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import Space from "@modules/navigator/Space/Space.js";
import NavigatorRouter from "@modules/navigator/Navigator.router.js";

gsap.registerPlugin(ScrollToPlugin);

const Building = {
    isHiding: false,
    scene: null,
    svg: null,

    init() {
        this.el = $('[component="Building"]');
        // console.log(this.el)
        if (!this.el.length) return;

        this.data = NAVIGATOR_DATA;
        this.scene = this.el.attr('scene');
        this.svg = this.el.find('svg');
        this.floors = this.svg.find('.floor');
        this.canvas = this.el.find('.canvas');

        BuildingBubble.init(this.el);

        this.bind();
        // this.welcome();

        if(Navigator.scene === 'medical' && !App.isDesktop) {
            setTimeout(() => {
                $(this.floors[0]).trigger('click');
            }, 800)
        }

        if (App.isMobile) {
            $('[url="byty-a-nebytove-priestory"] [block="menu"] [method="renderMenu"]').hide();
        }
    },

    bind() {
        this.floors.unbind('mouseenter');
        this.floors.unbind('mouseleave');
        this.floors.unbind('click');
        this.svg.unbind('click');

        this.svg.click((evt) => {
            evt.stopPropagation();
            this.onLeave(evt);
            this.blink();
            BannerParallax.scrollToCenter();
        })

        // --- DESKTOP only ---
        if (App.isDesktop || App.isLandscape) {

            this.floors.click((evt) => {
                this.onClick(evt);
            })

            this.floors.mouseenter((evt) => {
                this.onEnter(evt);
            })

            this.floors.mouseleave((evt) => {
                this.onLeave(evt);
            })
        }

        // --- MOBILE and TABLET ---
        if (!App.isDesktop || App.isPortrait) {

            this.floors.click((evt) => {
                evt.stopPropagation();
                this.onEnter(evt);
                this.setActive(evt);
            })
        }
    },

    onClick(evt) {
        const nmb = parseInt($(evt.currentTarget).attr('id'));

        if (Navigator.scene === 'byty' && nmb <= 1) {
            if (nmb === 1) {
                window.location.href = `${window.location.origin}/obchodne-priestory`;
            }

            if (nmb === 0) {
                window.location.href = `${window.location.origin}/zdravotnicke-zariadenie`;
            }
            return;
        }

        NavigatorRouter.setFloor(nmb);
    },

    onEnter(evt) {
        const floor = evt.currentTarget;
        const id = parseInt($(floor).attr('id'));
        const data = this.data.floors[id];
        // if(!Object.keys(data.flats).length) return;
        if(this.debug) console.log('onEnter', id, data)

        $(floor).addClass('hover').siblings().removeClass('hover');
        BuildingBubble.show(data, floor, evt);

        this.isHiding = false;
    },

    onLeave(evt) {
        const floor = evt.currentTarget;
        $(floor).removeClass('hover')
        this.isHiding = true;

        setTimeout(() => {
            if (this.isHiding) {
                BuildingBubble.hide();
            }
        }, 300)
    },

    setActive(evt) {
        const floor = $(evt.currentTarget);
        this.floors.filter('.active').removeClass('active');
        floor.addClass('active');
    },

    blink() {
        this.floors.removeClass('active hover');
        gsap.timeline({})
            .fromTo(this.floors, {opacity: 0}, {opacity: 1, duration: 0.25, ease: "expo.out"})
            .fromTo(this.floors, {opacity: 1}, {opacity: 0, stagger: -0.05, duration: 0.25, ease: "expo.out", clearProps: 'all'}, 0.30)

        // gsap.timeline({})
        //     .to(this.floors, {opacity: 1, stagger: -0.05, duration: 0.5, ease: "expo.out"})
        //     .to(this.floors, {opacity: 0, stagger: 0.05, duration: 0.25, ease: "expo.out", clearProps: 'all'})
    },

    welcome() {
        const floors = [18, 17, 16, 15, 14, 13, 12];
        const time = 200;

        floors.forEach((i, index) => {
            setTimeout(() => {
                // console.log(this.floors.filter('[id="' + i + '"]'))
                this.floors.filter('[id="' + i + '"]').addClass('hover').siblings().removeClass('hover')
            }, index * time)
        })

        setTimeout(() => {
            this.floors.filter('.hover').removeClass('hover');
        }, floors.length * time)
    },


    resize() {
        if (!this.el.length) return;
        this.bind();
    },
}

export default Building;